import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Products18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 1.25C4.80964 1.25 4.25 1.80964 4.25 2.5V12.5C4.25 13.1904 4.80964 13.75 5.5 13.75H15.5C16.1904 13.75 16.75 13.1904 16.75 12.5V2.5C16.75 1.80964 16.1904 1.25 15.5 1.25H5.5ZM5.75 12.25V5.75H15.25V12.25H5.75ZM7.25 4.25H5.75V2.75H7.25V4.25ZM8.75 4.25H15.25V2.75H8.75V4.25Z'
      fill='currentColor'
    />
    <path
      d='M2.75 5V15.25H13V16.75H2.5C1.81917 16.75 1.25 16.1808 1.25 15.5V5H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Products18.displayName = 'Products18';
export default Products18;
